module.exports = __webpack_public_path__ + "static/media/automated-tire-inspection.4b8b96ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/automated-tire-inspection.svg
// module id = 2555
// module chunks = 2